// @ts-nocheck
/**
 * BODi Navigation
 *
 * Minimal JavaScript - only handles interactions.
 * - Categories subnav is always visible for the active tab
 * - Desktop: Category tab hover interactions (mini/mega menus)
 * - Mobile: Category submenu navigation
 * All HTML is pre-rendered by Liquid using Shopify's native menu system.
 */

(function () {
  "use strict";

  // Set body background color
  setTimeout(() => {
    document.body.style.backgroundColor = "#161819";
  }, 1000);

  // Check for debug mode
  const urlParams = new URLSearchParams(window.location.search);
  const isDebugMode = urlParams.has("debugBodiNav");

  // ========================================
  // Desktop Navigation
  // ========================================

  /**
   * Initialize tracking for all desktop navigation links
   */
  function initializeDesktopNavTracking() {
    const desktopNav = document.querySelector(".bodi-nav-desktop");
    if (!desktopNav) return;

    // Track all anchor tags in desktop navigation
    desktopNav.addEventListener("click", (e) => {
      const link = e.target.closest("a");
      if (link && link.href && window.BODi?.trackSelectCta) {
        window.BODi.trackSelectCta("select nav cta", link.href);
      }
    });
  }

  function initializeDesktopNav() {
    const timeouts = {
      megaMenu: {},
      miniMenu: {},
    };

    // Categories subnav is always visible - only handle category tab interactions
    const submenuWrapper = document.querySelector(".bodi-nav__submenu-wrapper");
    const megaMenu = submenuWrapper?.querySelector(".bodi-nav__mega-menu");
    const categoryTabs = submenuWrapper?.querySelectorAll(".bodi-nav__category-tab");

    if (submenuWrapper && categoryTabs && categoryTabs.length > 0) {
      categoryTabs.forEach((tab) => {
        // Skip direct link categories (those without children)
        const isDirectLink =
          tab.tagName === "A" && tab.classList.contains("bodi-nav__category-tab--link");

        const menuType = tab.getAttribute("data-menu-type");
        const miniMenu = tab.querySelector(".bodi-nav__mini-menu");

        tab.addEventListener("mouseenter", () => {
          clearTimeout(timeouts.megaMenu.main);
          clearTimeout(timeouts.miniMenu.main);

          categoryTabs.forEach((t) => t.classList.remove("bodi-nav__category-tab--active"));
          tab.classList.add("bodi-nav__category-tab--active");

          submenuWrapper.querySelectorAll(".bodi-nav__mini-menu").forEach((menu) => {
            menu.classList.remove("bodi-nav__mini-menu--active");
          });

          // Don't activate menus for direct link categories
          if (isDirectLink) {
            if (megaMenu) megaMenu.classList.remove("bodi-nav__mega-menu--active");
          } else if (menuType === "mini" && miniMenu) {
            miniMenu.classList.add("bodi-nav__mini-menu--active");
            if (megaMenu) megaMenu.classList.remove("bodi-nav__mega-menu--active");
          } else if (menuType === "mega") {
            if (megaMenu) {
              megaMenu.classList.add("bodi-nav__mega-menu--active");

              // Switch to the correct category content
              const categoryHandle = tab.getAttribute("data-category");
              const allCategoryContents = submenuWrapper.querySelectorAll(
                ".bodi-nav__mega-menu-category-content"
              );
              allCategoryContents.forEach((content) => {
                if (content.getAttribute("data-category-content") === categoryHandle) {
                  content.classList.add("bodi-nav__mega-menu-category-content--active");
                } else {
                  content.classList.remove("bodi-nav__mega-menu-category-content--active");
                }
              });
            }
          }
        });

        if (!isDebugMode) {
          tab.addEventListener("mouseleave", () => {
            // For direct links (no menu), remove active state immediately
            if (isDirectLink) {
              tab.classList.remove("bodi-nav__category-tab--active");
              return;
            }

            if (menuType === "mini" && miniMenu) {
              timeouts.miniMenu.main = setTimeout(() => {
                if (!miniMenu.matches(":hover")) {
                  miniMenu.classList.remove("bodi-nav__mini-menu--active");
                  tab.classList.remove("bodi-nav__category-tab--active");
                }
              }, 150);
            } else if (menuType === "mega") {
              timeouts.megaMenu.main = setTimeout(() => {
                if (megaMenu && !megaMenu.matches(":hover")) {
                  megaMenu.classList.remove("bodi-nav__mega-menu--active");
                  tab.classList.remove("bodi-nav__category-tab--active");
                }
              }, 150);
            }
          });
        }

        if (miniMenu) {
          miniMenu.addEventListener("mouseenter", () => {
            clearTimeout(timeouts.miniMenu.main);
            miniMenu.classList.add("bodi-nav__mini-menu--active");
          });

          if (!isDebugMode) {
            miniMenu.addEventListener("mouseleave", () => {
              timeouts.miniMenu.main = setTimeout(() => {
                miniMenu.classList.remove("bodi-nav__mini-menu--active");

                // Remove active state from all category tabs when leaving mini menu
                categoryTabs.forEach((tab) => {
                  tab.classList.remove("bodi-nav__category-tab--active");
                });
              }, 150);
            });
          }
        }
      });

      if (megaMenu) {
        megaMenu.addEventListener("mouseenter", () => {
          clearTimeout(timeouts.megaMenu.main);
          megaMenu.classList.add("bodi-nav__mega-menu--active");
        });

        if (!isDebugMode) {
          megaMenu.addEventListener("mouseleave", () => {
            timeouts.megaMenu.main = setTimeout(() => {
              megaMenu.classList.remove("bodi-nav__mega-menu--active");

              // Remove active state from all category tabs when leaving mega menu
              categoryTabs.forEach((tab) => {
                tab.classList.remove("bodi-nav__category-tab--active");
              });
            }, 150);
          });
        }
      }
    }
  }

  // ========================================
  // Mobile Navigation
  // ========================================

  /**
   * Initialize tracking for all mobile navigation links
   */
  function initializeMobileNavTracking() {
    const mobileNav = document.querySelector(".bodi-nav-mobile");
    if (!mobileNav) return;

    // Track all anchor tags in mobile navigation using event delegation
    mobileNav.addEventListener("click", (e) => {
      const link = e.target.closest("a");
      if (link && link.href && window.BODi?.trackSelectCta) {
        window.BODi.trackSelectCta("select nav cta", link.href);
      }
    });
  }

  function initializeMobileNav() {
    const mobileState = {
      menuOpen: false,
      submenuActive: false,
      currentSubmenu: null,
      scrollPosition: 0,
    };

    const mobileHamburgerBtn = document.getElementById("bodiNavMobileHamburgerBtn");
    const mobileCloseBtn = document.getElementById("bodiNavMobileCloseBtn");
    const mobileMenuOverlay = document.getElementById("bodiNavMobileMenuOverlay");
    const mobileMainMenu = document.getElementById("bodiNavMobileMainMenu");
    const mobileSubmenu = document.getElementById("bodiNavMobileSubmenu");
    const mobileBackBtn = document.getElementById("bodiNavMobileBackBtn");
    const mobileSubmenuTitle = document.getElementById("bodiNavMobileSubmenuTitle");
    const mobileSubmenuContentWrapper = document.getElementById(
      "bodiNavMobileSubmenuContentWrapper"
    );
    const mobileSubmenuCtaButton = document.getElementById("bodiNavMobileSubmenuCtaButton");

    function lockBodyScroll() {
      // Store current scroll position
      mobileState.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      // Lock body scroll
      document.body.style.position = "fixed";
      document.body.style.top = `-${mobileState.scrollPosition}px`;
      document.body.style.width = "100%";
      document.body.classList.add("bodi-nav-menu-open");
    }

    function unlockBodyScroll() {
      // Unlock body scroll
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.classList.remove("bodi-nav-menu-open");

      // Restore scroll position
      window.scrollTo(0, mobileState.scrollPosition);
    }

    function openMenu() {
      mobileState.menuOpen = true;
      lockBodyScroll();
      mobileMenuOverlay.classList.add("bodi-nav-mobile__menu-overlay--active");
    }

    function closeMenu() {
      mobileState.menuOpen = false;
      mobileState.submenuActive = false;
      unlockBodyScroll();
      mobileMenuOverlay.classList.remove("bodi-nav-mobile__menu-overlay--active");

      mobileSubmenu.classList.remove("bodi-nav-mobile__submenu--active");
      mobileMainMenu.classList.remove("bodi-nav-mobile__main-menu--hidden");
    }

    function openSubmenu(categoryId) {
      // Get pre-rendered content from template
      const contentTemplate = document.querySelector(
        `script[data-category-content="${categoryId}"]`
      );

      if (!contentTemplate) return;

      const categoryInfo = window.bodiNavStructure.categories.find((c) => c.id === categoryId);

      if (!categoryInfo) return;

      mobileState.submenuActive = true;
      mobileState.currentSubmenu = categoryId;

      mobileSubmenuTitle.textContent = categoryInfo.name;
      mobileSubmenuContentWrapper.innerHTML = contentTemplate.innerHTML;

      // Get CTA data from template
      const ctaUrl = contentTemplate.getAttribute("data-cta-url") || "";
      const ctaText = contentTemplate.getAttribute("data-cta-text") || "";

      const mobileSubmenuCta = document.querySelector(".bodi-nav-mobile__submenu-cta");

      // Show/configure CTA for any menu type if [cta] link exists
      if (mobileSubmenuCta) {
        if (ctaUrl.trim() !== "" && ctaText.trim() !== "") {
          mobileSubmenuCta.style.display = "flex";
          if (mobileSubmenuCtaButton) {
            mobileSubmenuCtaButton.textContent = ctaText;
            // Remove existing click handler and add new one
            mobileSubmenuCtaButton.onclick = function () {
              window.location.href = ctaUrl;
            };
          }
        } else {
          // Hide CTA if no [cta] link is configured
          mobileSubmenuCta.style.display = "none";
        }
      }

      mobileMainMenu.classList.add("bodi-nav-mobile__main-menu--hidden");
      mobileSubmenu.classList.add("bodi-nav-mobile__submenu--active");
    }

    function closeSubmenu() {
      mobileState.submenuActive = false;
      mobileState.currentSubmenu = null;
      mobileSubmenu.classList.remove("bodi-nav-mobile__submenu--active");
      mobileMainMenu.classList.remove("bodi-nav-mobile__main-menu--hidden");

      const mobileSubmenuCta = document.querySelector(".bodi-nav-mobile__submenu-cta");
      if (mobileSubmenuCta) mobileSubmenuCta.style.display = "none";
    }

    // Event listeners
    mobileHamburgerBtn?.addEventListener("click", openMenu);
    mobileCloseBtn?.addEventListener("click", closeMenu);
    document.querySelectorAll(".bodi-nav-mobile__close-btn").forEach((btn) => {
      btn.addEventListener("click", closeMenu);
    });

    mobileBackBtn?.addEventListener("click", closeSubmenu);

    document.querySelectorAll("[data-mobile-submenu]").forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        const categoryId = item.getAttribute("data-mobile-submenu");
        openSubmenu(categoryId);
      });
    });

    mobileMenuOverlay?.addEventListener("click", (e) => {
      if (e.target === mobileMenuOverlay) closeMenu();
    });

    // Close menu when clicking footer links
    document.querySelectorAll(".bodi-nav-mobile__footer-link-item").forEach((link) => {
      link.addEventListener("click", closeMenu);
    });
  }

  // ========================================
  // Cart Button Handlers
  // ========================================

  function initializeCartButtons() {
    const bodiCartButtons = document.querySelectorAll(
      '.bodi-nav__cart-button, .bodi-nav-mobile__cart-button'
    );
    const rebuyDisabled = window.BODi?.configs?.rebuy?.smartCartDisabled ?? false;

    bodiCartButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        // Rebuy's own rebuy:smartcart.init listener handles this when active
        if (!rebuyDisabled) return;

        // If Recharge is installed, open Recharge cart drawer
        if (window.RechargePubSub) {
          window.RechargePubSub.publish('cart-drawer:open');
          return;
        }

        // Otherwise, open the native cart drawer
        event.preventDefault();
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer) {
          drawer.open();
        } else {
          const cartIcon = document.querySelector('cart-icon');
          cartIcon?.click();
        }
      });
    });
  }


  function intializeNav() {
    initializeDesktopNav();
    initializeDesktopNavTracking();
    initializeMobileNav();
    initializeMobileNavTracking();
  }

  // Initialize navigation
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", intializeNav);
  } else {
    intializeNav();
  }
})();
